import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineMail } from "react-icons/md";
// import { FaXTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa6";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { ValidationCons } from "../validation/validationConstant";
import { useFormik } from "formik";
import * as yup from "yup";
import { ContactFormApi } from "../service/apis/contact.api";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { ButtonLoader } from "../common/Loader/loader";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { cntctApi } from "../service/apis/pages.api";

const ContactUsScreen = () => {
    const { contactphone, contactemail, twitterUrl, linkedinUrl, instagramUrl } = useSelector((state: RootState) => {
        return state.globalDataSlice.Global;
    });
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const contactForm = useFormik({
        initialValues: {
            fName: "",
            lName: "",
            emailId: "",
            phoneNo: "",
            Messagee: ""
        },
        validationSchema: yup.object().shape({
            fName: yup
                .string()
                .trim()
                .required(ValidationCons.FIRST_NAME_REQUIRED),
            lName: yup
                .string()
                .trim()
                .required(ValidationCons.LAST_NAME_REQUIRED),
            emailId: yup
                .string()
                .email(ValidationCons.IS_EMAIL)
                .required(ValidationCons.EMAIL_REQUIRED),
            phoneNo: yup
                .string()
                .min(10, 'Must be at least 10 digits')
                .max(15, 'Must be at most 15 digits')
                .matches(/^\d+$/, 'Must contain only digits')
                .required(ValidationCons.PHONE_REQUIRED),
            Messagee: yup
                .string()
                .required(ValidationCons.MESSAGE),
        }),
        onSubmit: async (values, { resetForm }) => { 
            setIsLoading(true);
            //console.log(values);
            try {
                const bodyData = {
                    firstname: values.fName,
                    lastname: values.lName,
                    email: values.emailId,
                    phone: values.phoneNo,
                    message: values.Messagee,
                };
                const response = await ContactFormApi(bodyData);
                //console.log(response);
                if (response.message === "Message Sent Successfully!!!!") {
                    toast.success(response.message);
                    resetForm();
                } else {
                    toast.error("Failed to Submit!!");
                }
            } 
            catch(error) {
                console.log("Catch Error: " + error);
            }
            finally {
                setIsLoading(false);
            }
        },
    });

    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);

    const cntctContents = async() => {
            setIsLoading(true);
            try {
                const response = await cntctApi();
                //console.log(response);
                setResponseData(response?.pageData?.pageContent);
                setTitleSlug(response?.pageData);
            } catch (error) {
                console.error("Catch Error: ", error);
            } finally {
                setIsLoading(false);
            }
        };
    
    useEffect(() => {
        cntctContents();
    }, []);

    return (
        <>
            {/* <HeaderScreen /> */}
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="contactus-area common-padd-xl pt-0">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4">
                                <div className="contactus-connect">
                                    {responseData[0]?.type === "text" && responseData[0]?.content && (
                                        <h3>{responseData[0]?.content}</h3>
                                    )}
                                    {responseData[1]?.type === "text" && responseData[1]?.content && (
                                        <p>{responseData[1]?.content}</p>
                                    )}
                                    <ul className="connect">
                                        <li>
                                            <IoCallOutline />
                                            <div>
                                                <p>Call Us</p>
                                                <h4><a href={`callto:${contactphone}`}>{contactphone}</a></h4>
                                            </div>
                                        </li>
                                        <li>
                                            <MdOutlineMail />
                                            <div>
                                                <p>Mail Us</p>
                                                {/* <h4><a href=`mailto:${contactemail}`>{contactemail}</a></h4> */}
                                                <h4><Link to={`mailto:${contactemail}`}>{contactemail}</Link></h4>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="btmlinks">
                                        {responseData[4]?.type === "text" && responseData[4]?.content && (
                                            <h4>{responseData[4]?.content}</h4>
                                        )}
                                        <ul className="contactflowus">
                                            {twitterUrl && (
                                                <li>
                                                    <Link to={twitterUrl} target="_blank" rel="noopener noreferrer"><FaFacebook /></Link>
                                                </li>
                                            )}
                                            {linkedinUrl && (
                                                <li>
                                                    <Link to={linkedinUrl} target="_blank" rel="noopener noreferrer"><FaLinkedin /></Link>
                                                </li>
                                            )}
                                            {instagramUrl && (
                                                <li>
                                                    <Link to={instagramUrl} target="_blank" rel="noopener noreferrer"><FaInstagram /></Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 offset-lg-1">
                                <div className="contactus-holder">
                                    {responseData[2]?.type === "text" && responseData[2]?.content && (
                                        <h2>{responseData[2]?.content}</h2>
                                    )}
                                    {responseData[3]?.type === "textarea" && responseData[3]?.content && (
                                        <p>{responseData[3]?.content}</p>
                                    )}
                                    <Form onSubmit={contactForm.handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <Form.Group className="form-group mb-4">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter your first name"
                                                        name="fName"
                                                        onChange={contactForm.handleChange}
                                                        onBlur={contactForm.handleBlur}
                                                        value={contactForm.values.fName}
                                                        isInvalid={!!contactForm.errors.fName && contactForm.touched.fName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {contactForm.errors.fName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group className="form-group mb-4">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Enter your last name" 
                                                        name="lName"
                                                        onChange={contactForm.handleChange}
                                                        onBlur={contactForm.handleBlur}
                                                        value={contactForm.values.lName}
                                                        isInvalid={!!contactForm.errors.lName && contactForm.touched.lName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {contactForm.errors.lName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group className="form-group mb-4">
                                                    <Form.Label>Email Address</Form.Label>
                                                    <Form.Control 
                                                        type="email" 
                                                        placeholder="Enter your email address" 
                                                        name="emailId"
                                                        onChange={contactForm.handleChange}
                                                        onBlur={contactForm.handleBlur}
                                                        value={contactForm.values.emailId}
                                                        isInvalid={!!contactForm.errors.emailId && contactForm.touched.emailId}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {contactForm.errors.emailId}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group className="form-group mb-4">
                                                    <Form.Label>Phone Number</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Enter your phone number" 
                                                        name="phoneNo"
                                                        onChange={contactForm.handleChange}
                                                        onBlur={contactForm.handleBlur}
                                                        value={contactForm.values.phoneNo}
                                                        isInvalid={!!contactForm.errors.phoneNo && contactForm.touched.phoneNo}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {contactForm.errors.phoneNo}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-12">
                                                <Form.Group className="form-group mb-4">
                                                    <Form.Label>Your Message</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        placeholder="Do you have any question?" 
                                                        name="Messagee"
                                                        onChange={contactForm.handleChange}
                                                        onBlur={contactForm.handleBlur}
                                                        value={contactForm.values.Messagee}
                                                        isInvalid={!!contactForm.errors.Messagee && contactForm.touched.Messagee}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {contactForm.errors.Messagee}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <Button className="btn" type="submit"> 
                                                        {isLoading ? <ButtonLoader /> : "Send Message"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <ToastContainer />
            {/* <FooterScreen /> */}
        </>
    )
}
export default ContactUsScreen;